import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionForm from '../../../components/forms/CompetitionForm';
import { useCompetitionApi } from '../../../hooks/useCompetitionApi';
import { useNavigate } from 'react-router-dom';
import { CompetitionDTO } from '../../../services/apiClient';

const CompetitionCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competitions', href: '/admin/competitions' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Competition:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Competition.Edit'
    >
        <CompetitionForm
          initialValues={{} as CompetitionDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default CompetitionCreate;